// extracted by mini-css-extract-plugin
module.exports = {"card":"subscription_card__1tAnx","label":"subscription_label__fVRKA"};